/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/prefer-nullish-coalescing */
/* eslint-disable array-callback-return */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import Roboto from '../../../../../assets/fonts/Roboto-Bold.ttf'

import {
  Circle, ClipPath, Defs, Document,
  Font, G, Image, Line, Page, Path, Rect, StyleSheet, Svg, Text, View
} from '@react-pdf/renderer'
import React from 'react'
import { AssessmentReportResponse, IDadoGrafico2, iLinhaTabelaAvaliacoes, iSelo } from '../..'
import { iColaboradorBase, iCompetencia, iCompetenciaPDI, iPerfilPi } from '../../../../../interfaces'
import { ArrayToChunks, GroupBy } from '../../../../../Utils/Helper'
import { AssessmentResponse, iResponsavelPDL } from '../../../../PesquisaPercepcao/ResultadoIndividual'
import { iAcao } from '../Tabs/Recomendacoes'
import { PerfilPIGraficos } from '../../../../PesquisaPercepcao/ResultadoIndividual/components/PerfilPIGraficos'
import AltaLideranca from './assets/AltaLideranca.png'
import AutoAval from './assets/AutoAval.png'
import BarraLateralAgenda from './assets/BarraLateralAgenda.png'
import BarraLateralCapa from './assets/BarraLateralCapa.png'
import Contato from './assets/Contato.jpg'
import FundoRoxo from './assets/fundoRoxo.png'
import Gestor from './assets/Gestor.png'
import Gradient from './assets/gradient_a4_landscape.jpg'
import LearningModel from './assets/LearningModel.png'
import LicaoDeCasa from './assets/LicaoDeCasa.jpg'
import Liderados from './assets/Liderados.png'
import Logo2AH from './assets/Logo2AH.png'
import LogoAH from './assets/LogoAH.png'
import Outros from './assets/Outros.png'
import Pares from './assets/Pares.png'
import SlideIndicativa from './assets/SlideIndicativa.png'
import TextoFundoRoxo from './assets/TextoFundoRoxo.png'

// eslint-disable-next-line @typescript-eslint/no-unused-vars, @typescript-eslint/no-empty-interface
interface iModel {
  avaliado: iColaboradorBase
  competencias: iCompetencia[]
  comentarios: string[]
  logoEmpresa: string
  recomendacoes: iCompetenciaPDI[]
  perfilPI: iPerfilPi
  acoes: iAcao[]
  resumoCompetencias: iCompetenciaPDI[]
  eixos: number[]
  tabelaAvaliacoes2: iLinhaTabelaAvaliacoes[]
  combinado: AssessmentResponse
  responsavel: iResponsavelPDL
  relatorioPi: AssessmentReportResponse
  imagemPerfilPi?: string
  imagensQuadro: Array<{ base64: string, id: string }>
  grafico?: string
  graficoDados: IDadoGrafico2[]
}

export const RelatorioPDFPDL: React.FC<iModel> = ({ avaliado, comentarios, competencias, eixos, imagensQuadro, logoEmpresa, recomendacoes, acoes, perfilPI, resumoCompetencias, tabelaAvaliacoes2, combinado, responsavel, relatorioPi, grafico, graficoDados, imagemPerfilPi }) => {
  const graficoOrdenado = [...graficoDados].sort((a, b) => parseFloat(b.media) - parseFloat(a.media))

  Font.register({
    family: 'Roboto',
    fonts: [{
      src: Roboto
    }]
  })

  const styles = StyleSheet.create({
    DefaultPage: {
      paddingVertical: 16,
      paddingHorizontal: 32,
      flexDirection: 'column',
      justifyContent: 'space-between'
    },
    Title: {
      fontSize: '38px',
      fontFamily: 'Roboto',
      fontWeight: 'bold',
      color: '#fff'
    },
    TitleBlue: {
      fontSize: '15px',
      fontFamily: 'Roboto',
      fontWeight: 'bold',
      color: '#1961E0'
    },
    leftColumn: {
      width: 740,
      padding: 24,
      paddingLeft: 32,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      gap: 12,
      zIndex: -1
    },
    title: {
      fontSize: 42,
      color: '#66046B',
      fontWeight: 'bold',
      marginBottom: 8
    },
    card: {
      paddingLeft: 9,
      paddingVertical: 14,
      borderRadius: 4,
      fontSize: 20
    },
    activeCard: {
      backgroundColor: '#66046B',
      color: '#fff'
    },
    inactiveCard: {
      backgroundColor: '#e0e0e0',
      color: '#66046B'
    },
    rightImage: {
      height: 450
    },
    table: {
      display: 'flex',
      minWidth: 890,
      maxWidth: 890
    },
    tableRow: {
      margin: 'auto',
      flexDirection: 'row'
    },
    tableRow2: {
      margin: 'auto',
      flexDirection: 'row',
      backgroundColor: '#F0F0F0'
    },
    tableCol: {
      fontFamily: 'Roboto',
      fontWeight: 'bold'
    },
    tableHeaderCol: {
      color: 'black'
    },
    tableCell: {
      margin: 'auto',
      fontSize: 10,
      padding: 5,
      fontFamily: 'Roboto',
      fontWeight: 'bold',
      textAlign: 'center',
      minHeight: '26px',
      maxHeight: '26px',
      width: 890 / ([0, 1, 2, 3, 4, 6].filter(index => TemEixo(index)).length + 1)
    }
  })

  Font.registerHyphenationCallback((e) => {
    if (e.includes('http') && e.length > 100) {
      const arr: string[] = []
      for (let i = 0; i < e.length; i += 100) {
        arr.push(e.substring(i, i + 100))
      }
      return arr
    }

    if (e.includes('Flexibilidade/Adaptabilidade')) {
      return e.split('/')
    }

    if (e.includes('Autodesenvolvimento')) {
      return ['Autodesenvolvi', 'mento']
    }

    if (e.length === 1) {
      return [e, '']
    }
    return [e]
  })

  function returnCombinado(): any {
    return <PerfilPIGraficos combinado={combinado} imagemPerfilPi={imagemPerfilPi} />
  }

  function ObterIcone2(obj: iSelo): any {
    if (obj.selo === 4) {
      return <Svg width="16" height="16" viewBox="0 0 16 16" fill="none">
        <Path d="M0.500178 0H4.50008C4.6657 0 4.82195 0.084375 4.9157 0.221875L7.45001 4.02187C5.90318 4.15 4.51258 4.82187 3.46261 5.84375L0.0845632 0.778125C-0.0185593 0.625 -0.0279341 0.428125 0.0595638 0.265625C0.147062 0.103125 0.315808 0 0.500178 0ZM15.9154 0.778125L12.5374 5.84688C11.4905 4.825 10.0968 4.15313 8.54999 4.025L11.0843 0.221875C11.178 0.08125 11.3343 0 11.4999 0H15.4998C15.6842 0 15.8529 0.1 15.9404 0.265625C16.0279 0.43125 16.0186 0.625 15.9154 0.778125ZM13.4999 10.5C13.4999 13.5375 11.0374 16 8 16C4.96257 16 2.50013 13.5375 2.50013 10.5C2.50013 7.4625 4.96257 5 8 5C11.0374 5 13.4999 7.4625 13.4999 10.5ZM8.26249 7.53438C8.15625 7.31563 7.84688 7.31563 7.73751 7.53438L7.03752 8.95312C6.99377 9.04062 6.91253 9.1 6.81878 9.1125L5.25007 9.34062C5.00945 9.375 4.9157 9.66875 5.08757 9.84062L6.22192 10.9469C6.29067 11.0156 6.32192 11.1094 6.30629 11.2063L6.03755 12.7656C5.99692 13.0031 6.24692 13.1875 6.46254 13.075L7.8625 12.3375C7.94688 12.2937 8.05 12.2937 8.13437 12.3375L9.53434 13.075C9.74996 13.1875 9.99995 13.0062 9.95933 12.7656L9.69059 11.2063C9.67496 11.1125 9.70621 11.0156 9.77496 10.9469L10.9093 9.84062C11.0843 9.67187 10.9874 9.37812 10.7468 9.34062L9.18122 9.1125C9.08747 9.1 9.0031 9.0375 8.96248 8.95312L8.26249 7.53438Z" fill="#27AE60"/>
      </Svg>
    } else if (obj.selo === 1) {
      return <Svg width="16" height="17" viewBox="0 0 16 17" fill="none">
        <Path d="M2.457 0.656678C2.16014 0.425441 1.73829 0.453564 1.46955 0.719175L0.219623 1.96911C-0.0459869 2.23472 -0.0741103 2.65657 0.154002 2.95655L2.65386 6.20637C2.79448 6.39074 3.01634 6.5001 3.24758 6.5001H4.93811L8.34417 9.90617C7.88482 10.8124 8.03169 11.9498 8.79102 12.706L12.2908 16.2058C12.6814 16.5964 13.3158 16.5964 13.7064 16.2058L15.7063 14.2059C16.0969 13.8153 16.0969 13.181 15.7063 12.7904L12.2065 9.29057C11.4503 8.53437 10.3128 8.38438 9.40662 8.84372L6.00055 5.43766V3.75026C6.00055 3.51589 5.89118 3.29716 5.70682 3.15654L2.457 0.656678ZM0.622726 12.8779C0.225873 13.2747 0.000885511 13.8153 0.000885511 14.3778C0.000885511 15.5496 0.950833 16.4996 2.12264 16.4996C2.68511 16.4996 3.22571 16.2746 3.62256 15.8777L7.30361 12.1967C7.05987 11.5436 7.02237 10.8342 7.19111 10.1624L5.26309 8.23438L0.622726 12.8779ZM16 5.00019C16 4.67208 15.9656 4.35335 15.9 4.04712C15.825 3.69713 15.3969 3.60651 15.1438 3.85963L13.147 5.85639C13.0533 5.95013 12.9252 6.00326 12.7939 6.00326H11.0003C10.7253 6.00326 10.5003 5.77827 10.5003 5.50328V3.70651C10.5003 3.57527 10.5534 3.44715 10.6472 3.3534L12.6439 1.35664C12.897 1.10353 12.8064 0.675427 12.4564 0.600431C12.1471 0.53481 11.8284 0.500437 11.5002 0.500437C9.01601 0.500437 7.0005 2.51595 7.0005 5.00019V5.02519L9.66598 7.69066C10.7909 7.4063 12.0346 7.70629 12.9158 8.58749L13.4064 9.07809C14.9376 8.35938 16 6.80321 16 5.00019ZM3.25071 13.9997C3.25071 14.4153 2.91635 14.7496 2.50075 14.7496C2.08515 14.7496 1.75079 14.4153 1.75079 13.9997C1.75079 13.5841 2.08515 13.2497 2.50075 13.2497C2.91635 13.2497 3.25071 13.5841 3.25071 13.9997Z" fill="#F2994A"/>
      </Svg>
    } else if (obj.selo === 2) {
      return <Svg width="16" height="16" viewBox="0 0 16 16" fill="none">
          <Path d="M1.4875 10.0474L7.13438 16.212C7.36875 16.4678 7.67812 16.6104 8 16.6104C8.32188 16.6104 8.63125 16.4678 8.86563 16.212L14.5125 10.0474C15.4625 9.01321 16 7.56248 16 6.04598V5.83404C16 3.27973 14.4219 1.10181 12.2688 0.681576C10.8438 0.403855 9.39375 0.948335 8.375 2.13961L8 2.57812L7.625 2.13961C6.60625 0.948335 5.15625 0.403855 3.73125 0.681576C1.57812 1.10181 0 3.27973 0 5.83404V6.04598C0 7.56248 0.5375 9.01321 1.4875 10.0474Z" fill="#2F80ED"/>
        </Svg>
    } else if (obj.selo === 3) {
      return <Svg width="16" height="16" viewBox="0 0 16 16" fill="none">
        <Path d="M8 16C12.4187 16 16 12.4187 16 8C16 3.58125 12.4187 0 8 0C3.58125 0 0 3.58125 0 8C0 12.4187 3.58125 16 8 16ZM4.97813 12.1469C4.89688 12.4094 4.61563 12.5594 4.35313 12.475C4.09063 12.3906 3.94063 12.1125 4.025 11.85C4.5375 10.1906 6.13437 9 8 9C9.86563 9 11.4625 10.1906 11.9781 11.8531C12.0594 12.1156 11.9125 12.3969 11.65 12.4781C11.3875 12.5594 11.1062 12.4125 11.025 12.15C10.6406 10.9187 9.44062 10 8 10C6.55938 10 5.35938 10.9188 4.97813 12.1469ZM6.5125 6.5C6.5125 7.05313 6.06562 7.5 5.5125 7.5C4.95937 7.5 4.5125 7.05313 4.5125 6.5C4.5125 5.94687 4.95937 5.5 5.5125 5.5C6.06562 5.5 6.5125 5.94687 6.5125 6.5ZM10.5125 7.5C9.95937 7.5 9.5125 7.05313 9.5125 6.5C9.5125 5.94687 9.95937 5.5 10.5125 5.5C11.0656 5.5 11.5125 5.94687 11.5125 6.5C11.5125 7.05313 11.0656 7.5 10.5125 7.5Z" fill="#66046B"/>
      </Svg>
    } else {
      return <></>
    }
  }

  function GetIconAvaliadores(eixo: number): any {
    let aval: any

    switch (eixo) {
      case 0:
        aval = AutoAval
        break
      case 1:
      case 7:
        aval = Gestor
        break
      case 2:
        aval = Pares
        break
      case 3:
        aval = Liderados
        break
      case 4:
        aval = Outros
        break
      case 6:
        aval = AltaLideranca
        break
    }

    return <Image src={aval} style={{ width: '188px', objectFit: 'contain', marginHorizontal: '-20px' }}/>
  }

  const selos: any[] = [
    { Nome: 'Guardião', Definicao: 'Um Guardião é altruísta e colaborativo, com preferência por trabalho detalhado baseado em habilidades.', UrlAvatar: 'https://sigah.blob.core.windows.net/assets/selosPi/GuardianBadge.en-US.png' },
    { Nome: 'Individualista', Definicao: 'Um Individualista é altamente independente e persistente, orientado por resultados.', UrlAvatar: 'https://sigah.blob.core.windows.net/assets/selosPi/IndividualistBadge.en-US.png' },
    { Nome: 'Operador', Definicao: 'Um Operador é um membro da equipe paciente, consciencioso, descontraído e cooperativo.', UrlAvatar: 'https://sigah.blob.core.windows.net/assets/selosPi/OperatorBadge.en-US.png' },
    { Nome: 'Persuasivo', Definicao: 'Um Persuasivo constrói equipes, assume riscos, é aquele que persuade, é socialmente equilibrado e motivador.', UrlAvatar: 'https://sigah.blob.core.windows.net/assets/selosPi/PersuaderBadge.en-US.png' },
    { Nome: 'Promotor', Definicao: 'Um Promotor é extrovertido, casual, desinibido e persuasivo, com tendência à informalidade.', UrlAvatar: 'https://sigah.blob.core.windows.net/assets/selosPi/PromoterBadge.en-US.png' },
    { Nome: 'Adaptativo', Definicao: 'Um Adaptativo é um construtor de pontes, confortável com situações em mudança.', UrlAvatar: 'https://sigah.blob.core.windows.net/assets/selosPi/AdapterBadge.en-US.png' },
    { Nome: 'Altruísta', Definicao: 'Um Altruísta é agradável e cooperativo, com uma ética de trabalho eficiente e precisa.', UrlAvatar: 'https://sigah.blob.core.windows.net/assets/selosPi/AltruistBadge.en-US.png' },
    { Nome: 'Artesão', Definicao: 'Um Artesão é complacente e analítico, enquanto produz um trabalho altamente preciso e meticuloso.', UrlAvatar: 'https://sigah.blob.core.windows.net/assets/selosPi/CraftsmanBadge.en-US.png' },
    { Nome: 'Aventureiro', Definicao: 'Um Aventureiro é um pensador inovador e individualista, criativo, que não é intimidado pelo fracasso.', UrlAvatar: 'https://sigah.blob.core.windows.net/assets/selosPi/MaverickBadge.en-US.png' },
    { Nome: 'Capitão', Definicao: 'Um Capitão é um solucionador de problemas que gosta de mudanças e inovações, enquanto controla o quadro geral.', UrlAvatar: 'https://sigah.blob.core.windows.net/assets/selosPi/CaptainBadge.en-US.png' },
    { Nome: 'Colaborador', Definicao: 'Um Colaborador é um membro da equipe amigável, compreensivo, receptivo e paciente.', UrlAvatar: 'https://sigah.blob.core.windows.net/assets/selosPi/CollaboratorBadge.en-US.png' },
    { Nome: 'Controlador', Definicao: 'Um Controlador é orientado por detalhes e conservador, com preferência por alta qualidade e conhecimento técnico.', UrlAvatar: 'https://sigah.blob.core.windows.net/assets/selosPi/ControllerBadge.en-US.png' },
    { Nome: 'Crítico-Analítico', Definicao: 'Um Crítico-Analítico é intenso, com altos padrões de exigência e uma personalidade disciplinada e reservada.', UrlAvatar: 'https://sigah.blob.core.windows.net/assets/selosPi/AnalyzerBadge.en-US.png' },
    { Nome: 'Empreendedor', Definicao: 'Um Empreendedor é alguém que tem iniciativa, assume riscos, é motivado e orientado por objetivos.', UrlAvatar: 'https://sigah.blob.core.windows.net/assets/selosPi/VenturerBadge.en-US.png' },
    { Nome: 'Especialista', Definicao: 'Um Especialista é um trabalhador altamente preciso, frequentemente cético e respeita a autoridade.', UrlAvatar: 'https://sigah.blob.core.windows.net/assets/selosPi/SpecialistBadge.en-US.png' },
    { Nome: 'Estrategista', Definicao: 'Um Estrategista é orientado por resultados, inovador, analítico e tem um impulso para a mudança.', UrlAvatar: 'https://sigah.blob.core.windows.net/assets/selosPi/StrategistBadge.en-US.png' },
    { Nome: 'Estudioso', Definicao: 'Um Estudioso é preciso, reservado, imaginativo e busca um alto nível de conhecimento técnico.', UrlAvatar: 'https://sigah.blob.core.windows.net/assets/selosPi/ScholarBadge.en-US.png' }
  ]

  function getSeloInfoByNome(nomeSelo: string): { url: string, definicao: string } {
    const seloEncontrado = selos.find(selo => selo.Nome.toLowerCase() === nomeSelo.toLowerCase())
    if (!seloEncontrado) return { url: '', definicao: '' }

    return {
      url: seloEncontrado.UrlAvatar,
      definicao: seloEncontrado.Definicao
    }
  }

  function TemEixo(tipo: number): boolean {
    return tabelaAvaliacoes2.some(e => e.selos2?.some(r => r.stake === tipo))
  }

  function RenderizarBloco(e: iLinhaTabelaAvaliacoes, stake: number): any {
    return (
    <View style={{ ...styles.tableCell, borderRight: '2px solid #D6D6D6' }}>
      <div style={{ display: 'flex', flexDirection: 'row', gap: '8px', width: 890 / ([0, 1, 2, 3, 4, 6].filter(index => TemEixo(index)).length + 1), justifyContent: 'center' }}>
        {GroupBy(e.selos2.filter(e => e.stake === stake), (r) => r.selo).toList().map((a, i) => {
          return (
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', gap: '8px' }} key={i}>
                <Text>{a.data.length > 1 ? a.data.length : ''}</Text>
                {ObterIcone2(a.data[0])}
            </div>
          )
        })}
      </div>
    </View>
    )
  }

  function RetornarTabela(): any {
    return (<View style={styles.table}>
      <View style={styles.tableHeaderCol}>
          <View style={styles.tableRow}>
              <Text style={{ ...styles.tableCell, textAlign: 'left', paddingLeft: '16px' }}>Competências</Text>
              {TemEixo(0) && (<Text style={styles.tableCell}>Autoavaliação</Text>)}
              {TemEixo(1) && (<Text style={styles.tableCell}>Gestor</Text>)}
              {TemEixo(2) && (<Text style={styles.tableCell}>Pares</Text>)}
              {TemEixo(3) && (<Text style={styles.tableCell}>Liderados</Text>)}
              {TemEixo(4) && (<Text style={styles.tableCell}>Outros</Text>)}
              {TemEixo(6) && (<Text style={styles.tableCell}>Alta Liderança</Text>)}
          </View>
      </View>
      <View>
          {tabelaAvaliacoes2.map((e, i) => {
            return (
                  <View style={{ ...i % 2 === 0 ? styles.tableRow2 : styles.tableRow }} key={i}>
                      <Text style={{ ...styles.tableCell, textAlign: 'left', borderLeft: '2px solid #D6D6D6', borderRight: '2px solid #D6D6D6', paddingLeft: '16px' }}>{e.competencia}</Text>
                      {TemEixo(0) && (
                        RenderizarBloco(e, 0)
                      )}

                      {TemEixo(1) && (
                        RenderizarBloco(e, 1)
                      )}

                      {TemEixo(2) && (
                        RenderizarBloco(e, 2)
                      )}

                      {TemEixo(3) && (
                        RenderizarBloco(e, 3)
                      )}

                      {TemEixo(4) && (
                        RenderizarBloco(e, 4)
                      )}

                      {TemEixo(6) && (
                        RenderizarBloco(e, 6)
                      )}

                  </View>
            )
          })}

      </View>
  </View>)
  }

  function ReturnEixoPI(titulo: string, subtitulo: string, texto: string, color: string): any {
    return <View style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', width: 450, gap: '24px' }}>
      <Text style={{ fontFamily: 'Roboto', fontWeight: 'bold', fontSize: '18px', width: 90, textAlign: 'right', color: color }}>{titulo}</Text>
      <View style={{ color: color }}>
        <Svg color={color} fill={color} width="28" height="28" viewBox="0 0 6 4">
          <G fill={color}>
            <Path d="M0 0 L6 2 L0 4 Z" />
          </G>
        </Svg>
      </View>
      <View style={{ paddingVertical: '6px', display: 'flex', flexDirection: 'column', gap: '4px', fontSize: '16px', width: 450 }}>
        <Text style={{ fontFamily: 'Roboto', fontWeight: 'bold', color: color }}>{subtitulo}</Text>
        <Text style={{ textAlign: 'justify' }}>{texto}</Text>
      </View>
    </View>
  }

  return (
    <Document>
      <Page style={{ position: 'relative' }} orientation={'landscape'} size={{ height: 960, width: 540 }}>
        <View style={{ position: 'absolute', top: '0', left: '0' }}>
          <Image src={Gradient} style={{ height: 540, width: 960 }}/>
        </View>
        <View style={{ display: 'flex', flexDirection: 'column', gap: '24px', paddingTop: '84px', width: 960, alignItems: 'center', justifyContent: 'center' }}>
          <View style={{ display: 'flex', flexDirection: 'row', gap: '20px' }}>
            <Image src={LogoAH} style={{ width: '254px', height: '254px' }}/>
            <View style={{ display: 'flex', flexDirection: 'column', gap: '24px', paddingTop: '50px' }}>
              <View style={{ display: 'flex', flexDirection: 'row', gap: '14px', position: 'relative', height: '132px' }}>
                <Image source={BarraLateralCapa} style={{ width: '100px', objectFit: 'contain', position: 'absolute', top: '-24px', right: '-48px', zIndex: '99' }}/>
                <View style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                  <Text style={styles.Title}>Mentoring</Text>
                  <Text style={styles.Title}>Executivo</Text>
                  <Text style={styles.Title}>Assessment Inicial</Text>
                </View>
              </View>
              <Text style={{ fontSize: '24px', color: '#fff' }}>{avaliado.nome.toUpperCase()}</Text>
            </View>
          </View>
          <View style={{ display: 'flex', flexDirection: 'row', gap: '14px', width: 960, backgroundColor: '#fff', height: '92px', justifyContent: 'center' }}>
            <Image source={logoEmpresa} style={{ width: '210px', maxHeight: '84px', objectFit: 'contain' }}/>
          </View>
        </View>
      </Page>
      <Page orientation={'landscape'} size={{ height: 960, width: 540 }}>
        <Image src={SlideIndicativa} style={{ height: 540, width: 960 }}/>
      </Page>
      <Page orientation={'landscape'} style={{ display: 'flex', flexDirection: 'row', gap: 40, position: 'relative', paddingVertical: 0 }} size={{ height: 960, width: 540 }}>
        <Image
          src={FundoRoxo}
          style={{
            height: 540,
            width: 310
          }}
        />
        <View style={{ position: 'absolute', top: 78, left: 90, width: 320, height: 400, display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', backgroundColor: '#E3E3E3' }}>
          {returnCombinado()}
        </View>
        <View style={{ display: 'flex', flexDirection: 'column', width: 580 }}>
          <View style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', paddingTop: 32, paddingHorizontal: 32, gap: 6 }}>
            <View style={{ display: 'flex', flexDirection: 'row', gap: '6px', position: 'relative' }}>
              <Text style={{ fontSize: '32px', color: '#000000', marginBottom: 8 }}>Perfil Comportamental –</Text>
              <Text style={{ fontSize: '32px', color: '#66046B', marginBottom: 8 }}>PI ®</Text>
            </View>
            <View style={{ height: '2px', width: '76px', backgroundColor: '#66046B' }}></View>
          </View>
          <View style={{ height: 440, display: 'flex', flexDirection: 'column', gap: '26px', alignItems: 'flex-end', paddingHorizontal: 32, paddingTop: '30px' }}>
            {ReturnEixoPI('Self', 'É', 'Impulsos e motivadores básicos. “Fazendo as coisas Naturalmente”.', '#1961E0')}
            {ReturnEixoPI('Conceito do Self', 'Percebe', 'Como um indivíduo percebe as exigências do ambiente quanto ao seu comportamento ou  necessidade de mudanças.', '#EB5757')}
            {ReturnEixoPI('Síntese', 'Está', 'Como o indivíduo se comporta no seu trabalho atual. Uma combinação do Self com o  Conceito do Self.', '#27AE60')}
          </View>
          <View>
            <Image source={Logo2AH} style={{ width: '58px', objectFit: 'contain', position: 'absolute', right: '-20px', bottom: '-4px' }}/>
          </View>
        </View>
      </Page>
      <Page style={styles.DefaultPage} orientation={'landscape'} size={{ height: 960, width: 540 }}>
        <View style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start', gap: '12px', marginBottom: '6px' }}>
          <View style={{ display: 'flex', flexDirection: 'row', gap: '6px', position: 'relative' }}>
            <Text style={{ fontSize: '32px', color: '#000000', paddingTop: '4px' }}>Relatório </Text>
            <Text style={{ fontSize: '32px', color: '#66046B', paddingTop: '4px' }}>PI ® </Text>
          </View>
          <View style={{ height: '1px', width: '72px', backgroundColor: '#66046B' }}></View>
        </View>

    <View style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', gap: '18px', marginTop: '0px' }}>
          <View style={{ display: 'flex', flexDirection: 'column', gap: '18px', width: '960px', alignItems: 'flex-start', justifyContent: 'flex-start' }}>

            <Text style={{ fontSize: '14px', fontFamily: 'Roboto', color: '#d12317', fontWeight: 700, textAlign: 'left', width: '800px' }}>Resumo</Text>
            <View style={{ height: '1px', width: '300px', backgroundColor: '#999999', marginBottom: '10px' }}></View>
            <Text style={{ fontSize: '11px', lineHeight: '1.4', fontFamily: 'Roboto', fontWeight: 'bold', textAlign: 'left', width: '800px' }}>{relatorioPi.resumo}</Text>
          </View>

        </View>

        <View>
          <Image src={Logo2AH} style={{ position: 'absolute', right: -26, bottom: -8, width: 42, objectFit: 'contain' }}/>
        </View>
      </Page>

{relatorioPi.comportamentos.length < 1200 && (<Page style={styles.DefaultPage} orientation={'landscape'} size={{ height: 960, width: 540 }}>
        <View style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start', gap: '12px', marginBottom: '6px' }}>
          <View style={{ display: 'flex', flexDirection: 'row', gap: '6px', position: 'relative' }}>
            <Text style={{ fontSize: '32px', color: '#000000', paddingTop: '4px' }}>Relatório </Text>
            <Text style={{ fontSize: '32px', color: '#66046B', paddingTop: '4px' }}>PI ®</Text>
          </View>
          <View style={{ height: '1px', width: '72px', backgroundColor: '#66046B' }}></View>
        </View>

    <View style={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-start', alignContent: 'flex-start', justifyContent: 'space-between', gap: '18px', marginTop: '12px' }}>
          <View style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', gap: '5px', width: '480px' }}>
            <Text style={{ fontSize: '14px', fontFamily: 'Roboto', fontWeight: 400, textAlign: 'left', width: '400px', color: '#d12317' }}>Estratégias de Gerenciamento:</Text>
            <View style={{ height: '1px', width: '300px', backgroundColor: '#999999', marginBottom: '10px' }}></View>
            <Text style={{ fontSize: '11px', fontFamily: 'Roboto', fontWeight: 'normal', textAlign: 'left', width: '400px' }}>{relatorioPi.estrategiasGerenciamento}</Text>
          </View>
          <View style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', gap: '18px', width: '480px' }}>

            <View style={{ display: 'flex', flexDirection: 'column', gap: '5px', width: '480px' }}>
            <Text style={{ fontSize: '14px', fontFamily: 'Roboto', fontWeight: 400, textAlign: 'left', width: '400px', color: '#d12317' }}>Comportamentos mais fortes</Text>
            <View style={{ height: '1px', width: '300px', backgroundColor: '#999999', marginBottom: '10px' }}></View>
            <Text style={{ fontSize: '11px', fontFamily: 'Roboto', fontWeight: 'normal', textAlign: 'left', width: '400px' }}>{relatorioPi.comportamentos}</Text>
          </View>

          </View>

        </View>

        <View>
          <Image src={Logo2AH} style={{ position: 'absolute', right: -26, bottom: -8, width: 42, objectFit: 'contain' }}/>
        </View>
      </Page>)}

{relatorioPi.comportamentos.length >= 1200 && (<Page style={styles.DefaultPage} orientation={'landscape'} size={{ height: 960, width: 540 }}>
        <View style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start', gap: '12px', marginBottom: '6px' }}>
          <View style={{ display: 'flex', flexDirection: 'row', gap: '6px', position: 'relative' }}>
            <Text style={{ fontSize: '32px', color: '#000000', paddingTop: '4px' }}>Relatório </Text>
            <Text style={{ fontSize: '32px', color: '#66046B', paddingTop: '4px' }}>PI ®</Text>
          </View>
          <View style={{ height: '1px', width: '72px', backgroundColor: '#66046B' }}></View>
        </View>

    <View style={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-start', alignContent: 'flex-start', justifyContent: 'space-between', gap: '18px', marginTop: '12px' }}>
          <View style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', gap: '5px', width: '480px' }}>
            <Text style={{ fontSize: '14px', fontFamily: 'Roboto', fontWeight: 400, textAlign: 'left', width: '400px', color: '#d12317' }}>Estratégias de Gerenciamento:</Text>
            <View style={{ height: '1px', width: '300px', backgroundColor: '#999999', marginBottom: '10px' }}></View>
            <Text style={{ fontSize: '11px', fontFamily: 'Roboto', fontWeight: 'normal', textAlign: 'left', width: '400px' }}>{relatorioPi.estrategiasGerenciamento}</Text>
          </View>
          <View style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', gap: '18px', width: '480px' }}>
          </View>
        </View>

        <View>
          <Image src={Logo2AH} style={{ position: 'absolute', right: -26, bottom: -8, width: 42, objectFit: 'contain' }}/>
        </View>
      </Page>
)}
    {relatorioPi.comportamentos.length >= 1200 && (<Page style={styles.DefaultPage} orientation={'landscape'} size={{ height: 960, width: 540 }}>
        <View style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start', gap: '12px', marginBottom: '6px' }}>
          <View style={{ display: 'flex', flexDirection: 'row', gap: '6px', position: 'relative' }}>
            <Text style={{ fontSize: '32px', color: '#000000', paddingTop: '4px' }}>Relatório </Text>
            <Text style={{ fontSize: '32px', color: '#66046B', paddingTop: '4px' }}>PI ® </Text>
          </View>
          <View style={{ height: '1px', width: '72px', backgroundColor: '#66046B' }}></View>
        </View>

    <View style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', gap: '18px', marginTop: '0px' }}>
          <View style={{ display: 'flex', flexDirection: 'column', gap: '18px', width: '960px', alignItems: 'flex-start', justifyContent: 'flex-start' }}>

            <Text style={{ fontSize: '14px', fontFamily: 'Roboto', color: '#d12317', fontWeight: 700, textAlign: 'left', width: '800px' }}>Comportamentos mais fortes</Text>
            <View style={{ height: '1px', width: '300px', backgroundColor: '#999999', marginBottom: '10px' }}></View>
            <Text style={{ fontSize: '11px', lineHeight: '1.4', fontFamily: 'Roboto', fontWeight: 'bold', textAlign: 'left', width: '800px' }}>{relatorioPi.comportamentos}</Text>
          </View>

        </View>

        <View>
          <Image src={Logo2AH} style={{ position: 'absolute', right: -26, bottom: -8, width: 42, objectFit: 'contain' }}/>
        </View>
      </Page>)}

      <Page style={styles.DefaultPage} orientation={'landscape'} size={{ height: 960, width: 540 }}>
        <View style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start', gap: '12px', marginBottom: '6px' }}>
          <View style={{ display: 'flex', flexDirection: 'row', gap: '6px', position: 'relative' }}>
            <Text style={{ fontSize: '32px', color: '#000000', paddingTop: '4px' }}>Relatório </Text>
            <Text style={{ fontSize: '32px', color: '#66046B', paddingTop: '4px' }}>PI ®</Text>
          </View>
          <View style={{ height: '1px', width: '72px', backgroundColor: '#66046B' }}></View>
        </View>

    <View style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', gap: '18px', marginTop: '12px' }}>
          <View style={{ display: 'flex', flexDirection: 'column', gap: '5px', width: '480px' }}>
            <Text style={{ fontSize: '14px', fontFamily: 'Roboto', fontWeight: 400, textAlign: 'left', width: '400px', color: '#d12317' }}>Estilo de gerência</Text>
            <View style={{ height: '1px', width: '300px', backgroundColor: '#999999', marginBottom: '10px' }}></View>
            <Text style={{ fontSize: '11px', fontFamily: 'Roboto', fontWeight: 'normal', textAlign: 'left', width: '400px' }}>{relatorioPi.estiloGerencia}</Text>
          </View>
          <View style={{ display: 'flex', flexDirection: 'column', gap: '18px', width: '480px' }}>

            <Text style={{ fontSize: '14px', fontFamily: 'Roboto', color: '#d12317', fontWeight: 700, textAlign: 'left', width: '400px' }}>Estilo de venda</Text>
            <View style={{ height: '1px', width: '300px', backgroundColor: '#999999', marginBottom: '10px' }}></View>
            <Text style={{ fontSize: '11px', fontFamily: 'Roboto', fontWeight: 'normal', textAlign: 'left', width: '400px' }}>{relatorioPi.estiloVenda}</Text>

          </View>

        </View>

        <View>
          <Image src={Logo2AH} style={{ position: 'absolute', right: -26, bottom: -8, width: 42, objectFit: 'contain' }}/>
        </View>
      </Page>
      <Page style={styles.DefaultPage} orientation={'landscape'} size={{ height: 960, width: 540 }}>
        <View style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: '12px', marginBottom: '6px' }}>
          <View style={{ display: 'flex', flexDirection: 'row', gap: '6px', position: 'relative' }}>
            <Text style={{ fontSize: '32px', color: '#000000', paddingTop: '4px' }}>Quadro desenvolvimento pessoal </Text>
            <Text style={{ fontSize: '32px', color: '#66046B', paddingTop: '4px' }}>PI ®</Text>
          </View>
          <View style={{ height: '1px', width: '72px', backgroundColor: '#66046B' }}></View>
        </View>
        <View style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', gap: '12px' }}>
          {imagensQuadro.map(e => {
            return <Image src={e.base64} style={{ height: 430, width: 430 }}/>
          })}
        </View>
        <View>
          <Image src={Logo2AH} style={{ position: 'absolute', right: -26, bottom: -8, width: 42, objectFit: 'contain' }}/>
        </View>
      </Page>
      <Page style={{ ...styles.DefaultPage, position: 'relative' }} orientation={'landscape'} size={{ height: 960, width: 540 }}>
        <View style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: '16px', marginBottom: '-22px' }}>
          <View style={{ display: 'flex', flexDirection: 'row', gap: '6px', position: 'relative' }}>
            <Text style={{ fontSize: '32px', color: '#000000', paddingTop: '4px' }}>Avaliadores</Text>
          </View>
          <View style={{ height: '1px', width: '72px', backgroundColor: '#66046B' }}></View>
        </View>
        <View style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', gap: '30px', height: 440, alignItems: 'center' }}>
          {eixos.filter(e => e !== 7).sort((a, b) => a - b).map(e => {
            return GetIconAvaliadores(e)
          })}
        </View>
        <View>
          <Image source={Logo2AH} style={{ width: '58px', objectFit: 'contain', position: 'absolute', right: '-20px', bottom: '-4px' }}/>
        </View>
      </Page>
      <Page style={{ flexDirection: 'column', justifyContent: 'space-between', position: 'relative' }} orientation={'landscape'} size={{ height: 960, width: 540 }}>
        <Image source={Logo2AH} style={{ width: '58px', objectFit: 'contain', position: 'absolute', right: '10px', top: '12px' }}/>
        <View style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: '16px', paddingTop: 16, paddingHorizontal: 32, marginBottom: '4px' }}>
          <View style={{ display: 'flex', flexDirection: 'row', gap: '6px', position: 'relative', marginBottom: '-12px', alignItems: 'center' }}>
            <Text style={{ fontSize: '32px', color: '#000000', paddingTop: '4px' }}>Competências</Text>
            <Text style={{ fontSize: '32px', color: '#66046B', paddingTop: '4px' }}>utilizadas</Text>
            <View style={{ marginLeft: '26px', border: '8px solid #66046B', fontSize: '18px', borderRadius: '50%', padding: '10px', fontFamily: 'Roboto', fontWeight: 'bold' }}>
              <Text>{competencias.filter((e): e is iCompetencia => !e.discursiva).length}</Text>
            </View>
          </View>
          <View style={{ height: '1px', width: '72px', backgroundColor: '#66046B' }}></View>
        </View>
        <View style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', gap: '14px', paddingHorizontal: 32 }}>
          {ArrayToChunks(competencias.filter((e): e is iCompetencia => !e.discursiva), 6).map(comps => {
            return <View style={{ display: 'flex', flexDirection: 'row', justifyContent: comps.length === 7 ? 'space-between' : 'center', gap: comps.length === 7 ? '16px' : '42px' }}>
              {comps.map((r, i2) => {
                return (
                  <View key={i2} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '8px' }}>
                    <Image
                      src={r.icone.replace('Competencias-', 'Icones-SISTEMA-').replace('svg', 'png')}
                      style={{ width: 65, height: 65 }}
                    />
                    <Text style={{ fontSize: '14px', fontFamily: 'Roboto', fontWeight: 'bold', width: '110px', textAlign: 'center' }}>{r.nome}</Text>
                  </View>
                )
              }
              )}
            </View>
          })}
        </View>
        <View style={{ paddingVertical: 18, paddingHorizontal: 32, backgroundColor: '#CC42A2', color: '#ffffff', display: 'flex', flexDirection: 'row', gap: '20px', alignItems: 'center' }}>
          <View style={{ fontSize: '18px', fontFamily: 'Roboto', display: 'flex', flexDirection: 'row', gap: '6px' }}>
            <Text>O que é</Text>
            <Text style={{ fontWeight: 'bold' }}>competência?</Text>
          </View>
          <View style={{ height: '32px', width: '1px', backgroundColor: '#ffffff' }}></View>
          <View style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
            <Text style={{ fontSize: '13px' }}>É o conjunto de habilidades, comportamentos, atitudes e conhecimentos interrelacionados, que uma pessoa precisa</Text>
            <Text style={{ fontSize: '13px' }}>para ser eficaz em sua posição.</Text>
          </View>
        </View>
      </Page>
      {ArrayToChunks(competencias.filter(e => e.questoes.length > 0 && !e.discursiva), 3).map(comps => {
        return <Page style={{ ...styles.DefaultPage, position: 'relative' }} orientation={'landscape'} size={{ height: 960, width: 540 }}>
        <View style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: '16px', marginBottom: '6px' }}>
          <View style={{ display: 'flex', flexDirection: 'row', gap: '6px', position: 'relative', marginBottom: '-6px', alignItems: 'center' }}>
            <Text style={{ fontSize: '32px', color: '#000000', paddingTop: '4px' }}>Competências</Text>
            <Text style={{ fontSize: '32px', color: '#66046B', paddingTop: '4px' }}>utilizadas</Text>
          </View>
          <View style={{ height: '1px', width: '72px', backgroundColor: '#66046B' }}></View>
        </View>
        <View style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', gap: '30px' }}>
          {comps.map(e => {
            return <View style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '20px' }}>
              <View style={{ width: '120px', height: '100px' }}>
                <Image style={{ height: '100px', objectFit: 'contain' }} src={e.icone.replace('Competencias-', 'Icones-SISTEMA-').replace('svg', 'png')}/>
              </View>
              <View style={{ height: '100px', width: '2px', backgroundColor: '#66046B' }}></View>
              <View style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', fontSize: '14px', gap: '20px', width: '640px' }}>
               <Text style={{ fontSize: '12px', fontFamily: 'Roboto', color: '#66046B', fontWeight: 'bold', width: '300px', textAlign: 'left' }}>{e.nome}</Text>
                {e.questoes.map((q, i) => {
                  return <Text>{e.questoes.length > 1 ? `${i + 1} - ` : ''}{q.enunciado}</Text>
                })}
              </View>
            </View>
          })}
        </View>
        <View>
          <Image source={Logo2AH} style={{ width: '58px', objectFit: 'contain', position: 'absolute', right: '-20px', bottom: '-4px' }}/>
        </View>
      </Page>
      })}
      {grafico && <Page style={{ ...styles.DefaultPage, position: 'relative' }} orientation={'landscape'} size={{ height: 960, width: 540 }}>
        <Image source={Logo2AH} style={{ width: '58px', objectFit: 'contain', position: 'absolute', right: '10px', top: '12px' }}/>
        <View style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: '10px', marginBottom: '10px' }}>
          <View style={{ display: 'flex', flexDirection: 'row', gap: '6px', position: 'relative' }}>
            <Text style={{ fontSize: '32px', color: '#000000', paddingTop: '4px' }}>Competências</Text>
            <Text style={{ fontSize: '32px', color: '#66046B', paddingTop: '4px' }}>Intensidade</Text>
          </View>
          <View style={{ height: '1px', width: '72px', backgroundColor: '#66046B' }}></View>
          <Text style={{ fontSize: '14px', fontFamily: 'Roboto', fontWeight: 'bold', color: '#66046B' }}>Intensidade nas percepções dos stakeholders</Text>
        </View>
        <View style={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
          <Text style={{ fontSize: 9 }}>
            Resultante da quantidade de indicações por vertentes de Stakeholders de cada competência, nesta pesquisa cada Vertente tinha o mesmo peso e, cada Stakeholder selecionou 2 competências como destaque e 2 competências como pontos de atenção. Neste gráfico a nota máxima é +1 e a nota mínima -1. Exemplo caso você não tenha tido nenhuma indicação em determinada competência ela irá aparecer 0,00.
          </Text>
          <Image src={grafico} style={{ height: 260, objectFit: 'contain', marginTop: 4 }}/>
          <View style={{ display: 'flex', flexDirection: 'column', marginTop: 8 }}>
            {ArrayToChunks(graficoOrdenado, 2).map((linha, indexLinha) => (
              <View key={indexLinha} style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', marginBottom: 6 }}>
                {linha.map((e, i) => (
                  <Text key={`${indexLinha}-${i}`} style={{ flexGrow: 1, flexBasis: 0, fontSize: 9, marginRight: i === 0 ? 12 : 0 }}>
                    {`C${i + 1 + indexLinha * 2}. ${e.nome} (${e.media})`}
                  </Text>
                ))}
                {linha.length === 1 && <View style={{ flexGrow: 1, flexBasis: 0 }} />}
              </View>
            ))}
          </View>
        </View>
      </Page>}
      <Page style={{ ...styles.DefaultPage, position: 'relative' }} orientation={'landscape'} size={{ height: 960, width: 540 }}>
        <Image source={Logo2AH} style={{ width: '58px', objectFit: 'contain', position: 'absolute', right: '10px', top: '12px' }}/>
        <View style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: '16px', marginBottom: '14px' }}>
          <View style={{ display: 'flex', flexDirection: 'row', gap: '6px', position: 'relative' }}>
            <Text style={{ fontSize: '32px', color: '#000000', paddingTop: '4px' }}>Pesquisa</Text>
            <Text style={{ fontSize: '32px', color: '#66046B', paddingTop: '4px' }}>Indicativa</Text>
          </View>
          <View style={{ height: '1px', width: '72px', backgroundColor: '#66046B' }}></View>
        </View>
        <View style={{ display: 'flex', flexDirection: 'column', gap: '8px', height: 420, alignItems: 'center' }}>
          {resumoCompetencias.filter(e => e.status === 1).length > 0 && <View style={{ display: 'flex', gap: '8px', padding: 8 }}>
            <View style={{ display: 'flex', flexDirection: 'row', flexWrap: 'nowrap', alignItems: 'flex-start', gap: 8 }}>
              {ObterIcone2({ selo: 4, stake: 0 })}
              <Text style={{ fontSize: 16, color: '#27AE60' }}>Competências avaliadas pelos seus stakeholders como seus pontos fortes</Text>
            </View>
            {resumoCompetencias.filter(e => e.status === 1).map((item) => {
              return (<View style={{ display: 'flex', flexDirection: 'row', gap: 8 }}>
                <View style={{ display: 'flex', flexDirection: 'row', flexWrap: 'nowrap', alignItems: 'center', gap: '12px' }}>
                  <View style={{ display: 'flex', gap: 6, justifyContent: 'center', alignItems: 'center' }}>
                    <Image style={{ objectFit: 'contain', height: '48px' }} src={item.avatar?.replace('Competencias-', 'Icones-SISTEMA-').replace('svg', 'png')}/>
                    <Text style={{ fontSize: 11, width: '84px', textAlign: 'center' }}>{item.nome}</Text>
                  </View>
                  <View style={{ display: 'flex', gap: 4 }}>
                    <Text style={{ fontSize: 11, fontFamily: 'Roboto', fontWeight: 'bold', maxWidth: '740px' }}>Descrição: {item.descricao}</Text>
                    <Text style={{ fontSize: 11, maxWidth: '740px' }}>{item.pergunta}</Text>
                  </View>
                </View>
              </View>)
            })}
          </View>}
          {resumoCompetencias.filter(e => e.status === 0).length > 0 && <View style={{ display: 'flex', gap: '8px', padding: 8 }}>
            <View style={{ display: 'flex', flexDirection: 'row', flexWrap: 'nowrap', alignItems: 'flex-start', gap: 8 }}>
              {ObterIcone2({ selo: 1, stake: 0 })}
              <Text style={{ fontSize: 16, color: '#F2994A' }}>Competências avaliadas pelos seus stakeholders como prioridade para seu desenvolvimento profissional</Text>
            </View>
            {resumoCompetencias.filter(e => e.status === 0).map((item) => {
              return (<View style={{ display: 'flex', flexDirection: 'row', gap: 8 }}>
                <View style={{ display: 'flex', flexDirection: 'row', flexWrap: 'nowrap', alignItems: 'center', gap: '12px' }}>
                  <View style={{ display: 'flex', gap: 6, justifyContent: 'center', alignItems: 'center' }}>
                    <Image style={{ objectFit: 'contain', height: '48px' }} src={item.avatar?.replace('Competencias-', 'Icones-SISTEMA-').replace('svg', 'png')}/>
                    <Text style={{ fontSize: 11, width: '84px', textAlign: 'center' }}>{item.nome}</Text>
                  </View>
                  <View style={{ display: 'flex', gap: 4 }}>
                    <Text style={{ fontSize: 11, fontFamily: 'Roboto', fontWeight: 'bold', maxWidth: '740px' }}>Descrição: {item.descricao}</Text>
                    <Text style={{ fontSize: 11, maxWidth: '740px' }}>{item.pergunta}</Text>
                  </View>
                </View>
              </View>)
            })}
          </View>}
        </View>
      </Page>
      <Page style={{ ...styles.DefaultPage, position: 'relative' }} orientation={'landscape'} size={{ height: 960, width: 540 }}>
        <Image source={Logo2AH} style={{ width: '58px', objectFit: 'contain', position: 'absolute', right: '10px', top: '12px' }}/>
        <View style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: '16px', marginBottom: '14px' }}>
          <View style={{ display: 'flex', flexDirection: 'row', gap: '6px', position: 'relative' }}>
            <Text style={{ fontSize: '32px', color: '#000000', paddingTop: '4px' }}>Pesquisa</Text>
            <Text style={{ fontSize: '32px', color: '#66046B', paddingTop: '4px' }}>Indicativa</Text>
          </View>
          <View style={{ height: '1px', width: '72px', backgroundColor: '#66046B' }}></View>
        </View>
        <View style={{ display: 'flex', flexDirection: 'column', gap: '14px', height: 400, alignItems: 'center' }}>
          {resumoCompetencias.filter(e => e.status === 2).length > 0 && <View style={{ display: 'flex', gap: '30px', padding: 8 }}>
            <View style={{ display: 'flex', flexDirection: 'row', flexWrap: 'nowrap', alignItems: 'flex-start', gap: 8 }}>
              {ObterIcone2({ selo: 2, stake: 0 })}
              <Text style={{ fontSize: 16, color: '#2F80ED' }}>Competências que mais o motivam, quando aplicadas</Text>
            </View>
            <View style={{ display: 'flex', flexDirection: 'row', gap: '18px', alignItems: 'center' }}>
              {resumoCompetencias.filter(e => e.status === 2).map((item, i) => {
                return (<>
                  <View style={{ display: 'flex', flexDirection: 'row', gap: 8 }}>
                    <View style={{ display: 'flex', flexDirection: 'row', flexWrap: 'nowrap', alignItems: 'center', gap: '22px' }}>
                      <View style={{ display: 'flex', gap: 6, justifyContent: 'center', alignItems: 'center' }}>
                        <Image style={{ objectFit: 'contain', height: '56px' }} src={item.avatar?.replace('Competencias-', 'Icones-SISTEMA-').replace('svg', 'png')}/>
                        <Text style={{ fontSize: 11, width: '84px', textAlign: 'center' }}>{item.nome}</Text>
                      </View>
                      <View style={{ display: 'flex', gap: 4 }}>
                        <Text style={{ fontSize: 11, fontFamily: 'Roboto', fontWeight: 'bold', maxWidth: '300px' }}>Descrição:</Text>
                        <Text style={{ fontSize: 11, maxWidth: '300px' }}>{item.descricao}</Text>
                      </View>
                    </View>
                  </View>
                  {i === 0 && <View style={{ height: '64px', width: '1px', backgroundColor: '#66046B' }}></View>}
                </>)
              })}
            </View>
          </View>}
          {resumoCompetencias.filter(e => e.status === 1).length > 0 && <View style={{ display: 'flex', gap: '30px', padding: 8 }}>
            <View style={{ display: 'flex', flexDirection: 'row', flexWrap: 'nowrap', alignItems: 'flex-start', gap: 8 }}>
              {ObterIcone2({ selo: 3, stake: 0 })}
              <Text style={{ fontSize: 16, color: '#66046B' }}>Competências que menos o motivam, quando aplicadas</Text>
            </View>
            <View style={{ display: 'flex', flexDirection: 'row', gap: '18px', alignItems: 'center' }}>
              {resumoCompetencias.filter(e => e.status === 3).map((item, i) => {
                return (<>
                  <View style={{ display: 'flex', flexDirection: 'row', gap: 8 }}>
                    <View style={{ display: 'flex', flexDirection: 'row', flexWrap: 'nowrap', alignItems: 'center', gap: '22px' }}>
                      <View style={{ display: 'flex', gap: 6, justifyContent: 'center', alignItems: 'center' }}>
                        <Image style={{ objectFit: 'contain', height: '56px' }} src={item.avatar?.replace('Competencias-', 'Icones-SISTEMA-').replace('svg', 'png')}/>
                        <Text style={{ fontSize: 11, width: '84px', textAlign: 'center' }}>{item.nome}</Text>
                      </View>
                      <View style={{ display: 'flex', gap: 4 }}>
                        <Text style={{ fontSize: 11, fontFamily: 'Roboto', fontWeight: 'bold', maxWidth: '300px' }}>Descrição:</Text>
                        <Text style={{ fontSize: 11, maxWidth: '300px' }}>{item.descricao}</Text>
                      </View>
                    </View>
                  </View>
                  {i === 0 && <View style={{ height: '64px', width: '1px', backgroundColor: '#66046B' }}></View>}
                </>)
              })}
            </View>
          </View>}
          {resumoCompetencias.filter(e => e.status === 4).length > 0 && <View style={{ display: 'flex', gap: '30px', padding: 8 }}>
            <View style={{ display: 'flex', flexDirection: 'row', flexWrap: 'nowrap', alignItems: 'flex-start', gap: 8 }}>
              <Text style={{ fontSize: 16, color: '#828282' }}>Outras oportunidades de desenvolvimento</Text>
            </View>
            <View style={{ display: 'flex', flexDirection: 'row', gap: '18px', alignItems: 'center' }}>
              {resumoCompetencias.filter(e => e.status === 4).map((item, i) => {
                return (<>
                  <View style={{ display: 'flex', flexDirection: 'row', gap: 8 }}>
                    <View style={{ display: 'flex', flexDirection: 'row', flexWrap: 'nowrap', alignItems: 'center', gap: '22px' }}>
                      <View style={{ display: 'flex', gap: 6, justifyContent: 'center', alignItems: 'center' }}>
                        <Image style={{ objectFit: 'contain', height: '56px' }} src={item.avatar?.replace('Competencias-', 'Icones-SISTEMA-').replace('svg', 'png')}/>
                        <Text style={{ fontSize: 11, width: '84px', textAlign: 'center' }}>{item.nome}</Text>
                      </View>
                      <View style={{ display: 'flex', gap: 4 }}>
                        <Text style={{ fontSize: 11, fontFamily: 'Roboto', fontWeight: 'bold', maxWidth: '300px' }}>Descrição:</Text>
                        <Text style={{ fontSize: 11, maxWidth: '300px' }}>{item.descricao}</Text>
                      </View>
                    </View>
                  </View>
                  {i === 0 && <View style={{ height: '64px', width: '1px', backgroundColor: '#66046B' }}></View>}
                </>)
              })}
            </View>
          </View>}
        </View>
        <View>
        </View>
      </Page>
      <Page style={{ ...styles.DefaultPage, position: 'relative' }} orientation={'landscape'} size={{ height: 960, width: 540 }}>
        <Image source={Logo2AH} style={{ width: '58px', objectFit: 'contain', position: 'absolute', right: '10px', top: '12px' }}/>
        <View style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: '16px', marginBottom: '14px' }}>
          <View style={{ display: 'flex', flexDirection: 'row', gap: '6px', position: 'relative' }}>
            <Text style={{ fontSize: '32px', color: '#000000', paddingTop: '4px' }}>Pesquisa</Text>
            <Text style={{ fontSize: '32px', color: '#66046B', paddingTop: '4px' }}>Indicativa</Text>
          </View>
          <View style={{ height: '1px', width: '72px', backgroundColor: '#66046B' }}></View>
        </View>
        <View style={{ display: 'flex', flexDirection: 'column', gap: '14px', height: 400, alignItems: 'center' }}>
          {RetornarTabela()}
          <View style={{ fontSize: 10, marginTop: '16px' }}>
              <View style={{ display: 'flex', gap: '16px', justifyContent: 'center', flexDirection: 'row', marginBottom: '8px' }}>
                  <div style={{ display: 'flex', flexDirection: 'row', gap: '8px', alignItems: 'center' }}>{ObterIcone2({ selo: 4, stake: 0 })} <Text>Considera ser um destaque positivo</Text></div>
                  <div style={{ display: 'flex', flexDirection: 'row', gap: '8px', alignItems: 'center' }}>{ObterIcone2({ selo: 1, stake: 0 })}  <Text>Considera ter mais necessidade de desenvolvimento</Text></div>
              </View>
              <View style={{ display: 'flex', gap: '16px', justifyContent: 'center', flexDirection: 'row' }}>
                  <div style={{ display: 'flex', flexDirection: 'row', gap: '8px', alignItems: 'center' }}>{ObterIcone2({ selo: 2, stake: 0 })}  <Text>Que você mais se motiva</Text></div>
                  <div style={{ display: 'flex', flexDirection: 'row', gap: '8px', alignItems: 'center' }}>{ObterIcone2({ selo: 3, stake: 0 })}  <Text>Que você menos se motiva</Text></div>
              </View>
          </View>
        </View>
        <View>
        </View>
      </Page>
      {ArrayToChunks(comentarios, 5).map(grupo => {
        return <Page style={{ ...styles.DefaultPage, position: 'relative', gap: '22px' }} orientation={'landscape'} size={{ height: 960, width: 540 }}>
          <View style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: '16px' }}>
            <View style={{ display: 'flex', flexDirection: 'row', gap: '6px', position: 'relative', marginBottom: '-6px', alignItems: 'center' }}>
              <Text style={{ fontSize: '32px', color: '#000000', paddingTop: '4px' }}>Comentários</Text>
            </View>
            <View style={{ height: '1px', width: '72px', backgroundColor: '#66046B' }}></View>
          </View>
          <View style={{ flex: 1 }}>
            <View style={{ position: 'relative', display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '18px', justifyContent: 'center', backgroundColor: '#F0F0F0', gap: '8px' }}>
              {grupo.map(c => {
                return <View style={{ display: 'flex', flexDirection: 'row', gap: '8px' }}>
                  <Svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                    <Path d="M4 12L10 18L20 6" stroke="#E91E63" stroke-width="2" fill="none"/>
                  </Svg>
                  <Text style={{ width: '840px', fontSize: '12px' }}>{c}</Text>
                </View>
              })}
            </View>
          </View>
          <View>
            <Image source={Logo2AH} style={{ width: '58px', objectFit: 'contain', position: 'absolute', right: '-20px', bottom: '-14px' }}/>
          </View>
        </Page>
      })}
      <Page orientation={'landscape'} style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', gap: 40, position: 'relative', paddingVertical: 0 }} size={{ height: 960, width: 540 }}>
        <View style={{ display: 'flex', flexDirection: 'column', width: 580 }}>
          <View style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', paddingTop: 32, paddingHorizontal: 32, gap: 6 }}>
            <View style={{ display: 'flex', flexDirection: 'row', gap: '6px', position: 'relative' }}>
              <Text style={{ fontSize: '32px', color: '#000000', marginBottom: 8 }}>Relatório Integrado –</Text>
              <Text style={{ fontSize: '32px', color: '#66046B', marginBottom: 8 }}>Visão Individual</Text>
            </View>
            <View style={{ height: '2px', width: '76px', backgroundColor: '#66046B' }}></View>
          </View>
          <View style={{ height: 440, display: 'flex', flexDirection: 'column', gap: '16px', alignItems: 'flex-start', paddingHorizontal: 32, paddingTop: '18px' }}>
            <View style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              <Text style={styles.TitleBlue}>Perfil comportamental</Text>
              <View style={{ display: 'flex', flexDirection: 'row', gap: '12px', alignItems: 'center' }}>
                <Image src={getSeloInfoByNome(perfilPI.nomeSelo).url} style={{ width: '34px', height: '34px' }}/>
                <Text style={{ fontSize: '13px', width: 440 }}>{getSeloInfoByNome(perfilPI.nomeSelo).definicao}</Text>
              </View>
            </View>
            <View style={{ display: 'flex', flexDirection: 'column', height: 150 }}>
            </View>
            <View style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              <Text style={{ ...styles.TitleBlue, color: '#F2994A' }}>Competências para desenvolvimento</Text>
              <View style={{ display: 'flex', flexDirection: 'column', gap: '14px', justifyContent: 'center' }}>
                {resumoCompetencias.filter(e => e.status === 0).map((item) => {
                  return (<View style={{ display: 'flex', flexDirection: 'row', gap: 8 }}>
                    <View style={{ display: 'flex', flexDirection: 'row', flexWrap: 'nowrap', alignItems: 'center', gap: '9px' }}>
                      <View style={{ display: 'flex', gap: 6, justifyContent: 'center', alignItems: 'center' }}>
                        <Image style={{ objectFit: 'contain', height: '38px' }} src={item.avatar?.replace('Competencias-', 'Icones-SISTEMA-').replace('svg', 'png')}/>
                        <Text style={{ fontSize: 10, width: '84px', textAlign: 'center' }}>{item.nome}</Text>
                      </View>
                      <View style={{ display: 'flex', gap: 2 }}>
                        <Text style={{ fontSize: 10, fontFamily: 'Roboto', fontWeight: 'bold', width: 405, textAlign: 'justify' }}>Descrição: {item.descricao}</Text>
                        <Text style={{ fontSize: 10, width: 405, textAlign: 'justify' }}>{item.pergunta}</Text>
                      </View>
                    </View>
                  </View>)
                })}
              </View>
            </View>
          </View>
          <View>
          </View>
        </View>
        <Image
          src={FundoRoxo}
          style={{
            height: 540,
            width: 310
          }}
        />
        <View style={{ position: 'absolute', top: 78, right: 90, width: 320, height: 400, display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', backgroundColor: '#E3E3E3' }}>
          {returnCombinado()}
        </View>
      </Page>
      {acoes.filter(e => e.acao !== 'Desenvolvimento Geral').map(e => {
        return <Page style={{ ...styles.DefaultPage, position: 'relative' }} orientation={'landscape'} size={{ height: 960, width: 540 }}>
          <Image source={Logo2AH} style={{ width: '58px', objectFit: 'contain', position: 'absolute', right: '10px', top: '12px' }}/>
          <View style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: '16px' }}>
            <View style={{ display: 'flex', flexDirection: 'row', gap: '6px', position: 'relative', marginBottom: '-6px', alignItems: 'center' }}>
              <Text style={{ fontSize: '32px', color: '#000000', paddingTop: '4px' }}>Plano de Desenvolvimento</Text>
              <Text style={{ fontSize: '32px', color: '#66046B', paddingTop: '4px' }}>Individual</Text>
            </View>
            <View style={{ height: '1px', width: '72px', backgroundColor: '#66046B' }}></View>
          </View>
          <View style={{ display: 'flex', flexDirection: 'row', gap: 25, height: 440, alignItems: 'center' }}>
            <View style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              <Image src={LearningModel} style={{ width: 290, objectFit: 'contain' }}/>
              <Text style={{ fontSize: '11px', fontFamily: 'Roboto', width: 290, textAlign: 'center' }}>70% - Aprendizado através de atividades no dia a dia, vivenciar as experiências na prática, testar e se desafiar</Text>
              <Text style={{ fontSize: '11px', fontFamily: 'Roboto', width: 290, textAlign: 'center' }}>20% - Aprendizado com os outros como observação, pessoas que servem como modelo ou referência</Text>
              <Text style={{ fontSize: '11px', fontFamily: 'Roboto', width: 290, textAlign: 'center' }}>10% - Aprendizado formal, cursos estruturados, palestras, leituras...</Text>
            </View>
            <View style={{ width: '1px', height: 420, backgroundColor: '#66046B' }}></View>
            <View style={{ display: 'flex', flexDirection: 'column', gap: '16px', height: 440 }}>
              <View style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', flexDirection: 'row', gap: '10px', borderBottom: '1px solid #66046B', paddingHorizontal: 12, paddingBottom: 12 }}>
                {e.icone && <View style={{ marginLeft: '-12px' }}>
                  <Image src={e.icone?.replace('Competencias-', 'Icones-SISTEMA-').replace('svg', 'png')} style={{ width: 82, height: 82 }}/>
                </View>}
                <View style={{ display: 'flex', flexDirection: 'column' }}>
                  <Text style={{ width: 457, fontSize: 18, color: '#66046B', fontFamily: 'Roboto', marginBottom: '8px', paddingTop: '10px' }}>{e.acao}</Text>
                  {e.pergunta && <Text style={{ width: 457, fontSize: '14px', textAlign: 'justify' }}>{e.pergunta}</Text>}
                </View>
              </View>
              <View style={{ flexDirection: 'column', gap: '14px' }}>
                <View style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                  <Text style={{ fontSize: e.comoFazer.length > 800 ? '13px' : '15px', fontFamily: 'Roboto', fontWeight: 'bold' }}>O que fazer?</Text>
                  <Text style={{ fontSize: e.comoFazer.length > 800 ? '12px' : '14px', width: 570, textAlign: 'justify' }}>{e.oqueFazer}</Text>
                </View>
                <View style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                  <Text style={{ fontSize: e.comoFazer.length > 800 ? '13px' : '15px', fontFamily: 'Roboto', fontWeight: 'bold' }}>Como fazer?</Text>
                  <Text style={{ fontSize: e.comoFazer.length > 800 ? '12px' : '14px', width: 570, textAlign: 'justify' }}>{e.comoFazer}</Text>
                </View>
              </View>
            </View>
          </View>
          <View>
          </View>
        </Page>
      })}
      <Page orientation={'landscape'} style={{ ...styles.DefaultPage, position: 'relative', paddingVertical: 0 }} size={{ height: 960, width: 540 }}>
        <Image
          src={TextoFundoRoxo}
          style={{
            position: 'absolute',
            height: 540,
            width: 300,
            top: 0,
            right: 0
          }}
        />

        <Image
          src={LicaoDeCasa}
          style={{
            width: 340,
            position: 'absolute',
            top: 166,
            right: 44
          }}
        />

        <Image
          src={BarraLateralAgenda}
          style={{
            height: 95,
            width: 95,
            position: 'absolute',
            top: 378,
            right: 31
          }}
        />

        <View style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: '16px', paddingTop: 16 }}>
          <View style={{ display: 'flex', flexDirection: 'row', gap: '6px', position: 'relative', marginBottom: '-6px', alignItems: 'center' }}>
            <Text style={{ fontSize: '32px', color: '#000000', paddingTop: '4px' }}>Lição de</Text>
            <Text style={{ fontSize: '32px', color: '#66046B', paddingTop: '4px' }}>casa</Text>
          </View>
          <View style={{ height: '1px', width: '72px', backgroundColor: '#66046B' }}></View>
        </View>

        <View style={{ width: 740, paddingVertical: 24, display: 'flex', flexDirection: 'column', justifyContent: 'center', gap: 22, zIndex: -1 }}>
          <Text style={{ fontSize: '16px', width: 480, fontFamily: 'Roboto', fontWeight: 'bold' }}>
            Pesquisar sobre cursos, conhecimento específicos para complementar o PDI, mantendo a <Text style={{ color: '#CC42A2' }}>metodologia de aprendizagem 70/20/10:</Text>
          </Text>
          <View style={{ display: 'flex', flexDirection: 'column', gap: '12px', fontSize: '13px', width: 480, paddingLeft: 24 }}>
            <Text><Text style={{ fontFamily: 'Roboto', fontWeight: 'bold' }}>• 70% do tempo</Text> do seu desenvolvimento deve ser dedicado para o <Text style={{ color: '#CC42A2', fontFamily: 'Roboto', fontWeight: 'bold' }}>aprendizado através de atividades no dia a dia</Text><Text style={{ fontFamily: 'Roboto', fontWeight: 'bold' }}>, vivenciar as experiências na prática</Text></Text>
            <Text><Text style={{ fontFamily: 'Roboto', fontWeight: 'bold' }}>• 20% do tempo</Text> do seu desenvolvimento deve ser dedicado para o <Text style={{ color: '#CC42A2', fontFamily: 'Roboto', fontWeight: 'bold' }}>aprendizado com os outros</Text> (observação, pessoas que servem como modelo, exemplo ou referência, mentoring)</Text>
            <Text><Text style={{ fontFamily: 'Roboto', fontWeight: 'bold' }}>• 10% do tempo</Text> do seu desenvolvimento deve ser dedicado para o <Text style={{ color: '#CC42A2', fontFamily: 'Roboto', fontWeight: 'bold' }}>aprendizado formal</Text>, como por exemplo cursos, palestras, leituras, workshops.</Text>
          </View>
          <Text style={{ fontSize: '16px', width: 480 }}>
            <Text style={{ color: '#CC42A2', fontFamily: 'Roboto', fontWeight: 'bold' }}>Validar com seu gestor imediato</Text> os pontos de desenvolvimento (comportamental e/ou técnico).
          </Text>
        </View>
        <View style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start' }}>
          <Image source={Logo2AH} style={{ width: '58px', objectFit: 'contain' }} />
        </View>
      </Page>
      <Page orientation={'landscape'} size={{ height: 960, width: 540 }}>
        <Image src={Contato} style={{ width: 960, height: 540 }}/>
        <View style={{ display: 'flex', flexDirection: 'column', position: 'absolute', fontFamily: 'Roboto', fontWeight: 'bold', left: 96, top: 372, gap: 17, fontSize: 16, color: '#66046B' }}>
          <Text>{responsavel.nome}</Text>
          <Text>{responsavel.email}</Text>
          <Text>{responsavel.numero}</Text>
          <Text>{responsavel.numeroEmpresa}</Text>
        </View>
      </Page>
    </Document>
  )
}
